(() => {
	angular.module('main').directive('changeModal', changeModal);

	changeModal.$inject = ['$http', '$rootScope', '$location', 'messageService'];

	function changeModal($http, $rootScope, $location, messageService) {
		return {
			restrict: 'AE',
			scope: {
				task: '<',
				jobId: '<',
				leadId: '<'
			},
			template: ` <section>
                        <div id="main-wrapper" class="container">
                        <div id="modalChangeLead" class="modal modal-center fade" data-backdrop="static"
                     data-keyboard="false">
                    <div class="modal-dialog" ng-show="leadId" style="width: 550px">
                        <div class="modal-content">
                            <div class="modal-body fs-16" style="text-align: center; padding-top: 40px!important; font-weight: 500; color:black">
                             Once "Job accepted" is checked, this lead becomes a job. It will move from the "Leads" page to the "Jobs" page.
                            </div>
                            <div class="modal-footer modal-foot" style="display: flex; justify-content: center">
                                <button type="button" class="btn btn-success btn-submit" style="" ng-click="changeToJob(task, jobId)"
                                        spinning-wheel is-spinning-wheel-active="isSaveNotesSpinnningWheelActive">
                                   Yes, check "job accepted"
                                </button>
                                <button type="button" class="btn btn-lg btn-default ml-10"
                                        data-dismiss="modal"
                                        ng-click="cancelModalChange(task)"
                                        ng-disabled="button_disabled"
                                >Cancel
                                </button>
                            </div>
                       
                    </div>
                    </div>
                    <div class="modal-dialog" ng-show="!leadId" style="width: 550px">
                        <div class="modal-content">
                            <div class="modal-body fs-16"  style="text-align: center; padding-top: 40px!important; font-weight: 500; color:black">
                              Once "Job accepted" is unchecked, this job becomes a lead. It will move from the "Jobs" page to the "Leads" page.
                            </div>
                            <div class="modal-footer modal-foot" style="display: flex; justify-content: center">
                                <button type="button" class="btn btn-success btn-submit" ng-click="changeToLead(task, jobId)"
                                        spinning-wheel is-spinning-wheel-active="isSaveNotesSpinnningWheelActive">
                                   Yes, uncheck "job accepted"
                                </button>
                                <button type="button" class="btn btn-lg btn-default ml-10"
                                        data-dismiss="modal"
                                        ng-click="cancelModalChange(task)"
                                        ng-disabled="button_disabled"
                                >Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                </section>
`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.changeToJob = (task, jobId) => {
					$rootScope.dnd.canMove = false;
					$http({
						method: 'POST',
						url: `/protected/rest/jobs/${jobId}/accept`,
						data: JSON.stringify(task.completed)
					}).then(result => {
						$('#modalChangeLead').modal('hide');
						messageService.showToaster('s_0', 'lead');
						if (result.data.name === 'Job') {
							$location.path(`/jobs/view/${result.data.id}`);
						} else {
							console.log('this is lead');
						}
					});
				};

				scope.changeToLead = (task, jobId) => {
					$rootScope.dnd.canMove = false;
					$http({
						method: 'POST',
						url: `/protected/rest/jobs/${jobId}/accept`,
						data: JSON.stringify(task.completed)
					}).then(result => {
						$('#modalChangeLead').modal('hide');
						messageService.showToaster('s_1', 'lead');
						if (result.data.name === 'Lead') {
							$location.path(`/leads/view/${result.data.id}`);
						} else {
							console.log('this is job');
						}
					});
				};

				scope.cancelModalChange = task => {
					task.completed = !task.completed;
					// task.disabled=true;
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/changeModal.js